<template>
  <div>
    <div class="row">
      <div class="col-md-12 pa10">
        <div class="content-wizard pa20">
          <div class="row">
            <div class="col-md-12 largeTitle">
              <i class="fa fa-arrow-right"></i>
              Recherche du véhicule
              <hr>
            </div>
          </div>
          <div class="row is-flex">
            <div class="col-md-5">
              <label>Par plaque d'immatriculation</label>
              <div :class="{ 'sk-loading': getDataFromLicensePlateIsLoading }">
                <spinner-double-bounce :displayNone="!getDataFromLicensePlateIsLoading"/>
                <p class="centerText" v-if="getDataFromLicensePlateIsLoading">
                  Nous identifions le véhicule …
                </p>
                <div class="input-group" v-show="!getDataFromLicensePlateIsLoading">
                  <input type="text"
                         class="form-control"
                         placeholder="Immatriculation"
                         maxlength=9
                         @keyup="onKeyupVehicleLicensePlate"
                         @keyup.enter="getDataFromLicensePlate"
                         v-model="vehicle.licensePlate">
                  <span class="input-group-btn">
                                    <button type="button"
                                            @click="getDataFromLicensePlate"
                                            class="btn"
                                            :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
                                    >
                                        Rechercher
                                    </button>
                                </span>
                </div>
              </div>
            </div>
            <div class="col-md-2 centerText">
              <label>OU</label>
            </div>
            <div class="col-md-5">
              <button
                  @click="showStepByStepFormAction"
                  type="button"
                  class="btn btn-w-m btn-default maxWidth300px"
              >
                Recherche Manuelle
              </button>
            </div>
          </div>
          <div class="row mt20" v-if="getDataFromLicensePlateSuccess">
            <div class="col-md-12" v-if="!vehicle.make.id">
              <p class="text-error">
                Désolé mais nous ne parvenons pas à identifier cette immatriculation
              </p>
            </div>
            <div class="col-md-12" v-if="vehicleIsTooOld">
              <p class="text-error">
                {{ vehicleIsTooOldMessage }}
              </p>
            </div>
            <div v-if="!vehicleIsTooOld && vehicle.make.id" class="col-md-6 centerText">
              <img v-if="versionOptions" :src="vehicle.image" alt="" class="maxWidth80">
              <div v-else class="col-md-6">
                Nous ne trouvons pas de version pour ce véhicule, veuillez essayer la recherche manuelle, avec ces
                informations :
              </div>
            </div>

            <div v-if="!vehicleIsTooOld && vehicle.make.id" class="col-md-6">
              <p>Date de mise en circulation : <strong>{{ this.saveVehicle.dateMEC }}</strong></p>
              <p>Date du certificat d’immatriculation : <strong>{{ this.saveVehicle.dateCg }}</strong></p>
              <p>Marque : <strong>{{ this.saveVehicle.make.name }}</strong></p>
              <p>Modèle : <strong>{{ this.saveVehicle.model.name }}</strong></p>
              <p>Carrosserie : <strong>{{ this.saveVehicle.body.name }}</strong></p>
              <p>Boîte de vitesse : <strong>{{ this.saveVehicle.gearType.name }}</strong></p>
              <p>Nombre de portes : <strong>{{ this.saveVehicle.doors.name }}</strong></p>
              <p>Carburant : <strong>{{ this.saveVehicle.fuel.name }}</strong></p>
            </div>
          </div>
          <div class="row mt20 pl20">
            <div v-show="showStepByStepForm">
              <div class="form-group maxWidth400px"
                   :class="{'has-error': vehicle.dateMEC ? vehicleIsTooOld : false}"
                   id="data_3"
              >
                <label>Date de mise en circulation</label>
                <div class="input-group date">
                  <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                  <input type="text"
                         id="vehicleDateMEC"
                         class="form-control"
                         autoComplete="off"
                  >
                </div>
                <p v-if="vehicle.dateMEC && vehicleIsTooOld"
                   class="text-error"
                >
                  {{ vehicleIsTooOldMessage }}
                </p>
              </div>
              <div class="mt20" v-if="vehicle.yearMEC && vehicle.monthMEC && makeOptions">
                <label for="makeOptions">Marque</label>
                <select id="makeOptions"
                        @change="onChangeMakeOptions()"
                        class="form-control border-none maxWidth400px"
                        v-model="vehicle.make">
                  <option :value="null">Sélectionner une marque</option>
                  <option v-for="option in makeOptions"
                          :key="option.id"
                          :value="option">
                    {{ option.name }}
                  </option>
                </select>
              </div>
              <div class="mt20" v-if="vehicle.make.id && modelOptions">
                <label for="modelOptions">Modèle</label>
                <select id="modelOptions"
                        @change="onChangeModelOptions()"
                        class="form-control border-none maxWidth400px"
                        v-model="vehicle.model">
                  <option :value="null">Sélectionner une modèle</option>
                  <option v-for="option in modelOptions"
                          :key="option.id"
                          :value="option">
                    {{ option.name }}
                  </option>
                </select>
              </div>
              <div class="mt20" v-if="vehicle.model.id && bodyOptions">
                <label>Carosserie</label>
                <button
                    v-for="option in bodyOptions"
                    :key="option.id"
                    @click="updateVehicleBodyValue(option)"
                    type="button"
                    class="btn btn-w-m mt20 mr6"
                    :class="[option.name === vehicle.body.name ? 'btn-primary' : 'btn-secondary']"
                >
                  {{ option.name }}
                </button>
              </div>
              <div class="mt20" v-if="vehicle.body.id && fuelOptions">
                <label>Carburant</label>
                <button
                    v-for="option in fuelOptions"
                    :key="option.name"
                    @click="updateVehicleFuelValue(option)"
                    type="button"
                    class="btn btn-w-m mt20 mr6"
                    :class="[option.name === vehicle.fuel.name ? 'btn-primary' : 'btn-secondary']"
                >
                  {{ option.name }}
                </button>
              </div>
              <div class="mt20" v-if="vehicle.fuel.name && gearTypeOptions">
                <label>Boite de vitesse</label>
                <button
                    v-for="option in gearTypeOptions"
                    :key="option.id"
                    @click="updateVehicleGearTypeValue(option)"
                    type="button"
                    class="btn btn-w-m mt20 mr6"
                    :class="[option.name === vehicle.gearType.name ? 'btn-primary' : 'btn-secondary']"
                >
                  {{ option.name }}
                </button>
              </div>
              <div class="mt20" v-if="vehicle.gearType.name && doorsOptions">
                <label>Nombre de portes</label>
                <button
                    v-for="option in doorsOptions"
                    :key="option.id"
                    @click="updateVehicleDoorsValue(option)"
                    type="button"
                    class="btn btn-w-m mt20 mr6"
                    :class="[option.name === vehicle.doors.name ? 'btn-primary' : 'btn-secondary']"
                >
                  {{ option.name }}
                </button>
              </div>
            </div>

            <div class="mt20"
                 v-if="(getDataFromLicensePlateSuccess && vehicle.make.id && !vehicleIsTooOld && versionOptions) || (vehicle.doors.name && !vehicleIsTooOld && versionOptions)">
              <label for="versionOptions">
                Version
              </label>
              <select id="versionOptions"
                      class="form-control border-none maxWidth400px"
                      v-model="vehicle.version">
                <option :value="null">Sélectionner une version</option>
                <option v-for="option in versionOptions"
                        :key="option.id"
                        :value="option">
                  {{ option.name }}
                </option>
              </select>
            </div>

            <div class="form-group mt20"
                 :class="{'has-error': vehicle.kilometer ? disableGetPrice : false}"
                 v-if="isLastInputVisible"
            >
              <label>Kilométrage</label>
              <input type="number"
                     class="form-control maxWidth400px"
                     v-model="vehicle.kilometer">
              <p v-if="vehicle.kilometer && disableGetPrice"
                 class="text-error"
              >
                Désolé le véhicule ne respecte pas nos conditions
              </p>
            </div>

            <div class="form-group mt20 "
                 :class="{ 'sk-loading': getAvailablePartnersIsLoading }"
                 v-if="isLastInputVisible"
            >

              <div>
                <label>Code postal</label>
                <div class="maxWidth400px">
                  <spinner-double-bounce :displayNone="!getAvailablePartnersIsLoading"/>
                  <p class="centerText" v-if="getAvailablePartnersIsLoading">
                    Recherche des partenaires disponibles sur la zone …
                  </p>
                </div>
                <gmap-autocomplete ref="gmapAddress"
                                   class="form-control maxWidth400px"
                                   placeholder="ex: 75001"
                                   :componentRestrictions="{'country': ['fr']}"
                                   v-show="!getAvailablePartnersIsLoading"
                                   @place_changed="(p) => onPlaceChanged(p, 'vehicle')"/>
              </div>
            </div>
            <div class="row pa10 mt20" v-if="getAvailablePartnersError">
              <div class="col-md-12">
                <p class="text-error">
                  Désolé, un problème est survenu lors de la recherche des partenaires disponibles sur la zone. <br>
                  Veuillez essayer à nouveau.
                </p>
              </div>
            </div>
            <div class="row pa10 mt20"
                 v-if="
                                (getDataFromLicensePlateSuccess && vehicle.make.id && !vehicleIsTooOld) ||
                                (vehicle.version.id && !vehicleIsTooOld)
                            "
            >
              <div class="col-md-12">
                <p class="text-error"
                   v-if="vehicle.address !== '' &&
                                        vehicle.availablePartners &&
                                        vehicle.availablePartners.inspector === null &&
                                        vehicle.availablePartners.feuvert === null"
                >
                  Zone non couverte
                </p>
                <p class="text-success"
                   v-if="vehicle.address !== '' &&
                                        vehicle.availablePartners &&
                                        (vehicle.availablePartners.inspector || vehicle.availablePartners.feuvert)"
                >
                  Zone couverte
                </p>
              </div>
            </div>
            <div
                :class="{ 'sk-loading': getPriceIsLoading }"
            >
              <spinner-double-bounce :displayNone="!getPriceIsLoading"/>

              <button
                  @click="getPrice"
                  v-if="vehicle.kilometer && vehicle.version.id && !getPriceIsLoading && vehicle.address.zipCode.length === 5"
                  type="button"
                  :disabled="disableGetPrice"
                  :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
                  class="btn mt20 buttonLarge"
              >
                Obtenir un prix
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
        class="row"
    >
      <div class="col-md-12 pa10">
        <div class="content-wizard pa20">
          <div class="row">
            <div class="col-md-12 largeTitle">
              <i class="fa fa-search"></i>
              Rechercher une cotation existante
              <hr>
            </div>
          </div>
          <div class="row" v-if="showExistingQuotationFiltersClicked">
            <div class="col-md-4">
              <div class="form-group">
                <label>Prénom</label>
                <input type="text"
                       class="form-control"
                       placeholder="Prénom"
                       v-model="quote.firstName">
              </div>
              <div class="form-group">
                <label>Nom</label>
                <input type="text"
                       class="form-control"
                       placeholder="Nom"
                       v-model="quote.lastName">
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Email</label>
                <input type="text"
                       class="form-control"
                       placeholder="ex: carizy@carizy.com"
                       v-model="quote.email">
              </div>
              <div class="form-group">
                <label>Téléphone</label>
                <input type="text"
                       class="form-control"
                       maxlength=10
                       @keyup="onKeyupPhoneNumber"
                       placeholder="ex: 0789898989"
                       v-model="quote.phone">
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Immatriculation</label>
                <input type="text"
                       class="form-control"
                       placeholder="Immatriculation"
                       v-model="quote.licensePlate">
              </div>
            </div>
          </div>
          <div class="row" v-if="showExistingQuotationFiltersClicked">
            <div class="col-md-4">
              <button
                  @click="getExistingQuotes"
                  type="button"
                  class="btn btn-w-m"
                  :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
              >
                Rechercher
              </button>
            </div>
          </div>
          <div class="row mt30"
               v-if="getExistingQuotesClicked && showExistingQuotationFiltersClicked"
               :class="{ 'sk-loading': getExistingQuotesIsLoading }"
          >
            <spinner-double-bounce :displayNone="!getExistingQuotesIsLoading"/>

            <p v-if="existingQuoteList.length > 1 && !quotesWarningMessage" class="text-error">Attention, il existe
              plusieurs cotations.</p>
            <p v-if="existingQuoteList.length > 1 && quotesWarningMessage" class="text-error">Attention, il existe
              plusieurs cotations avec différent(e)s : <strong>{{ quotesWarningMessage }}</strong></p>
            <p v-if="existingQuoteList.length === 0 && !getExistingQuotesIsLoading" class="text-error">Il ne semble pas
              y avoir de cotation correspondante. Reprenons les informations du véhicule afin d’effectuer une nouvelle
              estimation. </p>

            <div class="table-responsive m-t">
              <table v-if="existingQuoteList.length"
                     class="table table-order table-hover table-striped">
                <thead>
                <tr>
                  <th>#</th>
                  <th class="w-100">Date de cotation</th>
                  <th class="w-100">Source</th>
                  <th class="w-150">Client</th>
                  <th class="w-150">Véhicule</th>
                  <th class="w-100">Kilométrage</th>
                  <th class="w-100">Prix net vendeur</th>
                  <th class="w-100">Code promo</th>
                  <th class="w-100">Validité</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in existingQuoteList"
                    :key="index">
                  <td>{{ item.id }}</td>
                  <td>{{ item.estimationDate }}</td>
                  <td>{{ item.originalSource }}</td>
                  <td>{{ item.customer.firstname }} {{ item.customer.lastname }}</td>
                  <td>{{ item.car.make }} - {{ item.car.model }} - {{ item.car.version }}</td>
                  <td>{{ item.car.kilometers }} Km</td>
                  <td>{{ item.sellerPrice }} €</td>
                  <td>{{ item.promoCode }}</td>
                  <td>
                    <div v-if="isQuotationValid(item.estimationDate)" class="text-success">
                      <i class="fa fa-check mr6"></i>&nbsp;<span>Valide</span>
                    </div>
                    <div v-else class="text-error">
                      <i class="fa fa-times mr6"></i>&nbsp;<span>Périmé</span>
                    </div>
                  </td>
                  <td>
                    <button v-if="isQuotationValid(item.estimationDate)"
                            @click="getExistingQuoteDetails(item.id)"
                            type="button"
                            class="btn btn-w-m"
                            :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']">
                      Choisir
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row pa17">
      <button
          v-if="showGoToPreviousStepButton"
          @click="goToPreviousStep"
          type="button"
          class="pull-left btn btn-w-m"
          :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
      >
        Précédent
      </button>
    </div>
  </div>
</template>


<script>
import gql from 'graphql-tag'
import moment from 'moment'
import 'moment/locale/fr'
import SpinnerDoubleBounce from '@/components/spinners/SpinnerDoubleBounce'
import {formatAddress, addressToString} from '../../../helpers/utils'


export default {
  name: "Identification",

  components: {
    SpinnerDoubleBounce
  },

  props: {
    activeStep: {
      type: Number,
      required: true
    },
    entity: {
      type: String,
      required: true
    },
    userInfos: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    initLoading: false,
    uploadLoading: false,
    quote: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      licensePlate: ""
    },
    getExistingQuotesClicked: false,
    getExistingQuotesIsLoading: false,
    existingQuoteList: [],
    quotesWarningMessage: "",
    saveVehicle: {
      dateMEC: "",
      dateCg: "",
      make: {
        name: null
      },
      model: {
        name: null
      },
      body: {
        name: null
      },
      gearType: {
        name: null
      },
      doors: {
        name: null
      },
      fuel: {
        name: null
      },
    },
    vehicle: {
      licensePlate: "",
      make: {
        id: null,
        name: null
      },
      model: {
        id: null,
        name: null
      },
      body: {
        id: null,
        name: null
      },
      gearType: {
        id: null,
        name: null
      },
      doors: {
        id: null,
        name: null
      },
      fuel: {
        name: null
      },
      version: {
        id: null,
        name: null
      },
      dateMEC: "",
      yearMEC: "",
      monthMEC: "",
      dateCg: "",
      kilometer: "",
      address: {
        address: "",
        city: "",
        zipCode: ""
      },
      availablePartners: []
    },
    getDataFromLicensePlateSuccess: false,
    getDataFromLicensePlateIsLoading: false,
    showStepByStepForm: false,
    makeOptions: null,
    modelOptions: null,
    bodyOptions: null,
    fuelOptions: null,
    gearTypeOptions: null,
    doorsOptions: null,
    vehicleLimitYear: 12,
    versionOptions: null,
    quotationData: null,
    showExistingQuotationFiltersClicked: true,
    showNewQuotationFormsClicked: true,
    showByLicensePlateSearchButton: true,
    showManualSearchButton: true,
    getPriceIsLoading: false,
    getAvailablePartnersIsLoading: false,
    getAvailablePartnersError: false,
    getAvailablePartnersNoDataError: false
  }),
  computed: {
    isLastInputVisible() {
      return ((this.getDataFromLicensePlateSuccess && this.vehicle.make.id && !this.vehicleIsTooOld && this.versionOptions != null)
          || (this.vehicle.version.id && !this.vehicleIsTooOld && this.versionOptions != null))
    },
    zipCodeIsNotValid() {
      if (this.vehicle.address.zipCode && this.vehicle.address.zipCode.length !== 5) {
        return true
      } else {
        return false
      }
    },

    disableGetPrice() {
      if (!this.vehicle.kilometer) {
        return true
      } else if (this.vehicle.kilometer < 6000) {
        return true
      } else if (this.vehicle.kilometer > 160000 && this.entity === 'carizy') {
        return true
      } else if (this.vehicle.kilometer > 120000 && this.entity === 'renault') {
        return true
      } else {
        return false
      }
    },
    showGoToPreviousStepButton() {
      return true
    },
    vehicleIsTooOld() {
      if (this.dateIsInMoreThan12YearsOld && this.entity === 'carizy') {
        return true
      } else if (this.dateIsInMoreThan8YearsOld && this.entity === 'renault') {
        return true
      } else {
        return false
      }
    },
    vehicleIsTooOldMessage() {
      if (this.vehicleIsTooOld && this.entity === 'carizy') {
        return "Malheureusement le véhicule a plus de 14 ans et ne correspond pas à nos critères!"
      } else if (this.vehicleIsTooOld && this.entity === 'renault') {
        return "Malheureusement le véhicule a plus de 8 ans et ne correspond pas à nos critères!"
      } else {
        return ""
      }
    },
    dateIsInMoreThan12YearsOld() {
      let date12YearsAgo = moment().subtract(14, 'years')
      return moment(date12YearsAgo).isAfter(moment(this.vehicle.dateMEC, "DD/MM/YYYY"))
    },
    dateIsInMoreThan8YearsOld() {
      let date8YearsAgo = moment().subtract(8, 'years')
      return moment(date8YearsAgo).isAfter(moment(this.vehicle.dateMEC, "DD/MM/YYYY"))
    },
    getCarPricingQuery() {
      let monthMEC = this.vehicle.monthMEC.charAt(0).toUpperCase() + this.vehicle.monthMEC.slice(1)
      let zipCode = parseInt(this.vehicle.address.zipCode)

      return gql`
                    query {
                    getCarPricing(
                        make: ${this.vehicle.make.id},
                        makeName: "${this.vehicle.make.name}",
                        model: ${this.vehicle.model.id},
                        modelName: "${this.vehicle.model.name}",
                        year: ${this.vehicle.yearMEC},
                        month: "${monthMEC}",
                        fuel: "${this.vehicle.fuel.name}",
                        gear: "${this.vehicle.gearType.name}",
                        doors: ${this.vehicle.doors.name},
                        version: "${this.vehicle.version.name}",
                        versionId: "${this.vehicle.version.id}",
                        kilometer: ${this.vehicle.kilometer},
                        zipcode: ${zipCode},
                        licensePlate: "${this.vehicle.licensePlate}"
                        ) {
                        maxPrice
                        minPrice
                        dealerPrice
                        sellerPrice
                        gain
                        image
                        tradeInPrice
                        }
                    }`
    },
  },
  mounted() {
    this.scrollToTop()
    this.initializeDatePicker()
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    goToPreviousStep() {
      this.$emit('go-to-previous-step', 0)
    },
    goToNextStep() {
      this.$emit('go-to-next-step', 2)
    },
    getExistingQuoteListWithoutAppraisal(quote) {
      return quote.appraisal.id === ""
    },
    async getExistingQuotes() {
      this.existingQuoteList = []
      this.getExistingQuotesClicked = true
      this.getExistingQuotesIsLoading = true

      const result = await this.$apollo.query({
        query: gql`
                      query {
                       quotation(realm: "${this.entity}", licensePlate: "${this.quote.licensePlate}", customer: { firstname: "${this.quote.firstName}", lastname: "${this.quote.lastName}", email: "${this.quote.email}", phone: "${this.quote.phone}" }) {
                            id
                            estimationDate
                            maxPrice
                            minPrice
                            dealerPrice
                            kilometers
                            originalSource
                            promoCode
                            licensePlate
                            sellerPrice
                            sellerPricePromo
                            realm
                            car {
                                id
                                make
                                model
                                version
                                color
                                fuel
                                licensePlate
                                city
                                department
                                kilometers
                                gearType
                                releaseDate
                                year
                                body
                                doorsNumber
                                vehicleRegistration
                                vehicleInspection
                                technicalControlValidity
                                photo
                                url
                                over4years
                                consVisit
                                registrationDate
                                typeVariantVersion
                                minesType
                                denomCommercial
                                vehicleIdentification
                                nationalGender
                                rateCO2
                                formulaNumber
                                cylindersNumber
                            }
                            customer {
                                id
                                civility
                                firstname
                                lastname
                                email
                                phone
                                organization
                                address {
                                    address
                                    city
                                    zipCode
                                }
                            }
                            appraisal {
                                id
                            }
                       }
                      }`,
        fetchPolicy: 'no-cache'
      })

      const existingQuoteList = result.data.quotation
      const existingQuoteListWithoutAppraisal = existingQuoteList.filter(this.getExistingQuoteListWithoutAppraisal);
      this.existingQuoteList = existingQuoteListWithoutAppraisal

      let duplicatesObject = this.getExistingQuotesDuplicates(existingQuoteListWithoutAppraisal)

      this.quotesWarningMessage = this.getWarningMessage(duplicatesObject)

      this.getExistingQuotesIsLoading = false
    },
    async getExistingQuoteDetails(id) {
      const result = await this.$apollo.query({
        query: gql`
                      query {
                       quotation(id: "${id}") {
                            id
                            estimationDate
                            maxPrice
                            minPrice
                            dealerPrice
                            kilometers
                            originalSource
                            promoCode
                            licensePlate
                            sellerPrice
                            sellerPricePromo
                            realm
                            gain
                            car {
                                id
                                make
                                model
                                version
                                color
                                fuel
                                licensePlate
                                city
                                department
                                kilometers
                                gearType
                                releaseDate
                                year
                                body
                                doorsNumber
                                vehicleRegistration
                                vehicleInspection
                                technicalControlValidity
                                photo
                                url
                                over4years
                                consVisit
                                registrationDate
                                typeVariantVersion
                                minesType
                                denomCommercial
                                vehicleIdentification
                                nationalGender
                                rateCO2
                                formulaNumber
                                cylindersNumber
                            }
                            customer {
                                id
                                civility
                                firstname
                                lastname
                                email
                                phone
                                organization
                                address {
                                    address
                                    city
                                    zipCode
                                }
                            }
                       }
                      }`,
        fetchPolicy: 'no-cache'
      })

      const quotation = result.data.quotation[0]

      this.quotationData = quotation

      this.vehicle.licensePlate = quotation.car.licensePlate
      this.vehicle.make.name = quotation.car.make
      this.vehicle.model.name = quotation.car.model
      this.vehicle.body.name = quotation.car.body
      this.vehicle.gearType.name = quotation.car.gearType
      this.vehicle.doors.name = quotation.car.doorsNumber
      this.vehicle.fuel.name = quotation.car.fuel
      this.vehicle.version.name = quotation.car.version
      this.vehicle.yearMEC = quotation.car.year
      this.vehicle.kilometer = quotation.car.kilometers ? quotation.car.kilometers : quotation.kilometers

      this.$emit('pass-quotation-data', this.quotationData)
      this.$emit('pass-vehicle-data', this.vehicle)

      this.$emit('go-to-next-step', 2)
    },
    showStepByStepFormAction() {
      this.showStepByStepForm = true
    },
    async getDataFromLicensePlate() {
      this.resetVehicleInfos(false)
      this.getDataFromLicensePlateIsLoading = true
      this.showStepByStepForm = false

      const result = await this.$apollo.query({
        query: gql`
                      query {
                       listVersionByLicensePlate(immat: "${this.vehicle.licensePlate}") {
                            dateMEC
                            yearMEC
                            monthMEC
                            dayMEC
                            dateCg
                            makeName
                            make
                            modelName
                            model
                            fuel
                            body
                            gearType
                            doors
                            version {
                                id
                                name
                                fullName
                            }
                            typeMine
                            vin
                            Co2
                            image
                       }
                      }`,
        fetchPolicy: 'no-cache'
      })

      const listVersionByLicensePlate = result.data.listVersionByLicensePlate

      this.vehicle.image = listVersionByLicensePlate.image
      this.vehicle.make.id = listVersionByLicensePlate.make
      this.vehicle.make.name = listVersionByLicensePlate.makeName
      this.vehicle.model.id = listVersionByLicensePlate.model
      this.vehicle.model.name = listVersionByLicensePlate.modelName
      this.vehicle.body.name = listVersionByLicensePlate.body
      this.vehicle.gearType.name = listVersionByLicensePlate.gearType
      this.vehicle.doors.name = listVersionByLicensePlate.doors
      this.vehicle.fuel.name = listVersionByLicensePlate.fuel
      this.vehicle.dateMEC = moment(listVersionByLicensePlate.dateMEC, "YYYY-MM-DD").format("DD/MM/YYYY")
      this.vehicle.yearMEC = listVersionByLicensePlate.yearMEC
      this.vehicle.monthMEC = listVersionByLicensePlate.monthMEC
      this.vehicle.dateCg = moment(listVersionByLicensePlate.dateCg, "YYYY-MM-DD").format("DD/MM/YYYY")
      this.versionOptions = listVersionByLicensePlate.version
      this.saveVehicle.dateMEC = moment(listVersionByLicensePlate.dateMEC, "YYYY-MM-DD").format("DD/MM/YYYY")
      this.saveVehicle.dateCg = moment(listVersionByLicensePlate.dateCg, "YYYY-MM-DD").format("DD/MM/YYYY")
      this.saveVehicle.make.name = listVersionByLicensePlate.makeName
      this.saveVehicle.model.name = listVersionByLicensePlate.modelName
      this.saveVehicle.body.name = listVersionByLicensePlate.body
      this.saveVehicle.gearType.name = listVersionByLicensePlate.gearType
      this.saveVehicle.doors.name = listVersionByLicensePlate.doors
      this.saveVehicle.fuel.name = listVersionByLicensePlate.fuel

      if (this.versionOptions != null && this.versionOptions.length === 1) {
        this.vehicle.version = this.versionOptions[0]
      }

      this.getDataFromLicensePlateSuccess = true
      this.getDataFromLicensePlateIsLoading = false
    },

    async getPrice() {
      this.getPriceIsLoading = true

      this.$apollo.query({
        query: this.getCarPricingQuery,
        fetchPolicy: 'no-cache'
      }).then(response => {
        this.quotationData = response.data.getCarPricing
        this.$emit('pass-quotation-data', this.quotationData)
        this.$emit('pass-vehicle-data', this.vehicle)

        this.$emit('go-to-next-step', 2)
        this.getPriceIsLoading = false
      }, () => {
        this.showBanner('danger', "Désolé, le prix n'est pas disponible.")
        this.getPriceIsLoading = false
      })
    },

    async getListMake() {
      const result = await this.$apollo.query({
        query: gql`
                      query {
                       listMake(vehicleLimitYear: ${this.vehicleLimitYear}) {
                            id
                            name
                       }
                      }`,
        fetchPolicy: 'no-cache'
      })

      this.makeOptions = result.data.listMake
    },

    async getListModel() {
      const result = await this.$apollo.query({
        query: gql`
                      query {
                       listModel(make: ${this.vehicle.make.id}, vehicleLimitYear: ${this.vehicleLimitYear}, year : ${this.vehicle.yearMEC}, date : "${moment(this.vehicle.dateMEC, "DD/MM/YYYY").format('YYYY-MM-DD')}") {
                            id
                            name
                       }
                      }`,
        fetchPolicy: 'no-cache'
      })

      this.modelOptions = result.data.listModel
    },

    async getListBody() {
      const result = await this.$apollo.query({
        query: gql`
                      query {
                       listBody(make: ${this.vehicle.make.id}, model: ${this.vehicle.model.id}, year : ${this.vehicle.yearMEC}, date : "${moment(this.vehicle.dateMEC, "DD/MM/YYYY").format('YYYY-MM-DD')}") {
                            id
                            name
                       }
                      }`,
        fetchPolicy: 'no-cache'
      })

      this.bodyOptions = result.data.listBody

      if (this.bodyOptions.length === 1) {
        this.vehicle.body = this.bodyOptions[0]
        this.onChangeBodyOptions()
      }
    },

    async getListFuel() {
      const result = await this.$apollo.query({
        query: gql`
                      query {
                       listFuel(make: ${this.vehicle.make.id}, model: ${this.vehicle.model.id}, year: ${this.vehicle.yearMEC}, date : "${moment(this.vehicle.dateMEC, "DD/MM/YYYY").format('YYYY-MM-DD')}") {
                            name
                       }
                      }`,
        fetchPolicy: 'no-cache'
      })

      this.fuelOptions = result.data.listFuel

      if (this.fuelOptions.length === 1) {
        this.vehicle.fuel = this.fuelOptions[0]
        this.onChangeFuelOptions()
      }
    },

    async getListGearType() {
      const result = await this.$apollo.query({
        query: gql`
                      query {
                       listGearType(make: ${this.vehicle.make.id}, model: ${this.vehicle.model.id}, year: ${this.vehicle.yearMEC}, fuel: "${this.vehicle.fuel.name}", date : "${moment(this.vehicle.dateMEC, "DD/MM/YYYY").format('YYYY-MM-DD')}") {
                            name
                       }
                      }`,
        fetchPolicy: 'no-cache'
      })

      this.gearTypeOptions = result.data.listGearType

      if (this.gearTypeOptions.length === 1) {
        this.vehicle.gearType = this.gearTypeOptions[0]
        this.onChangeGearTypeOptions()
      }
    },

    async getListDoors() {
      const result = await this.$apollo.query({
        query: gql`
                      query {
                       listDoors(make: ${this.vehicle.make.id}, model: ${this.vehicle.model.id}, year: ${this.vehicle.yearMEC}, fuel: "${this.vehicle.fuel.name}", gear: "${this.vehicle.gearType.name}", date : "${moment(this.vehicle.dateMEC, "DD/MM/YYYY").format('YYYY-MM-DD')}") {
                            name
                       }
                      }`,
        fetchPolicy: 'no-cache'
      })

      this.doorsOptions = result.data.listDoors

      if (this.doorsOptions.length === 1) {
        this.vehicle.doors = this.doorsOptions[0]
        this.onChangeDoorsOptions()
      }
    },

    async getListVersion() {
      const result = await this.$apollo.query({
        query: gql`
                      query {
                       listVersion(make: ${this.vehicle.make.id}, model: ${this.vehicle.model.id}, year: ${this.vehicle.yearMEC}, fuel: "${this.vehicle.fuel.name}", gear: "${this.vehicle.gearType.name}", doors: "${this.vehicle.doors.name}", date : "${moment(this.vehicle.dateMEC, "DD/MM/YYYY").format('YYYY-MM-DD')}") {
                            id
                            name
                       }
                      }`,
        fetchPolicy: 'no-cache'
      })

      this.versionOptions = this.formatVersionOptions(result.data.listVersion)
      if (this.versionOptions.length === 1) {
        this.vehicle.version = this.versionOptions[0]
      }
    },

    resetInputsOnDateChange() {
      this.makeOptions = null
      this.vehicle.make.name = null
      this.resetInputsOnChangeMakeOptions()
    },

    resetInputsOnChangeMakeOptions() {
      this.modelOptions = null
      this.vehicle.model.name = null
      this.resetInputsOnChangeModelOptions()
    },

    resetInputsOnChangeModelOptions() {
      this.bodyOptions = null
      this.vehicle.body.name = null
      this.resetInputsOnChangeBodyOptions()
    },

    resetInputsOnChangeBodyOptions() {
      this.fuelOptions = null
      this.vehicle.fuel.name = null
      this.resetInputsOnChangeFuelOptions()
    },

    resetInputsOnChangeFuelOptions() {
      this.gearTypeOptions = null
      this.vehicle.gearType.name = null
      this.resetInputsOnChangeGearTypeOptions()
    },

    resetInputsOnChangeGearTypeOptions() {
      this.doorsOptions = null
      this.vehicle.doors.name = null
      this.resetInputsOnChangeDoorsOptions()
    },

    resetInputsOnChangeDoorsOptions() {
      this.versionOptions = null
      this.vehicle.kilometer = null
      this.vehicle.address.zipCode = null
    },

    onChangeMakeOptions() {
      this.resetInputsOnChangeMakeOptions()
      this.getListModel()
    },

    onChangeModelOptions() {
      this.resetInputsOnChangeModelOptions()
      this.getListBody()
    },

    onChangeBodyOptions() {
      this.resetInputsOnChangeBodyOptions()
      this.getListFuel()
    },

    onChangeFuelOptions() {
      this.resetInputsOnChangeFuelOptions()
      this.getListGearType()
    },

    onChangeGearTypeOptions() {
      this.resetInputsOnChangeGearTypeOptions()
      this.getListDoors()
    },

    onChangeDoorsOptions() {
      this.resetInputsOnChangeDoorsOptions()
      this.getListVersion()
    },

    async onChangeDateMEC() {
      if (!this.vehicleIsTooOld) {
        this.vehicle.yearMEC = moment(this.vehicle.dateMEC, "DD/MM/YYYY").format('YYYY')
        this.vehicle.monthMEC = moment(this.vehicle.dateMEC, "DD/MM/YYYY").format('MMMM')

        await this.getListMake()
      }
    },
    onKeyupPhoneNumber(event) {
      if (event.key === "Backspace") {
        return
      }

      let formattedPhoneNumber = this.quote.phone.toUpperCase()
      this.quote.phone = formattedPhoneNumber.replace(/\s/, '').replace(/[a-zA-Z]/, '');
    },
    onKeyupVehicleLicensePlate(event) {
      if (event.key === "Backspace") {
        return
      }

      let formattedValue = this.vehicle.licensePlate.toUpperCase()

      if (formattedValue.length === 2) {
        formattedValue = formattedValue + "-"
      } else if (formattedValue.length === 6) {
        formattedValue = formattedValue + "-"
      }

      this.vehicle.licensePlate = formattedValue
    },

    resetVehicleInfos(resetLicensePlate) {
      if (resetLicensePlate) {
        this.vehicle.licensePlate = ""
      }

      this.vehicle.make = {
        id: null,
        name: null
      }
      this.vehicle.model = {
        id: null,
        name: null
      }
      this.vehicle.body = {
        id: null,
        name: null
      }
      this.vehicle.gearType = {
        id: null,
        name: null
      }
      this.vehicle.doors = {
        id: null,
        name: null
      }
      this.vehicle.fuel = {
        name: null
      }
      this.vehicle.version = {
        id: null,
        name: null
      }

      this.vehicle.dateMEC = ""
      this.vehicle.yearMEC = ""
      this.vehicle.monthMEC = ""
      this.vehicle.dateCg = ""
      this.vehicle.kilometer = ""

      this.getDataFromLicensePlateSuccess = false
      this.showStepByStepForm = false

      this.makeOptions = null
      this.modelOptions = null
      this.bodyOptions = null
      this.fuelOptions = null
      this.gearTypeOptions = null
      this.doorsOptions = null
      this.versionOptions = null

      this.vehicleLimitYear = 12

      this.initializeDatePicker()
    },

    initializeDatePicker() {
      $('#vehicleDateMEC').val(this.vehicle.dateMEC);

      $('#data_3 .input-group.date').datepicker({
        startView: 2,
        keyboardNavigation: false,
        forceParse: false,
        autoclose: true,
        format: "dd/mm/yyyy",
        weekStart: 1,
        language: 'fr',
        endDate: "0d"
      }).on(
          'changeDate', () => {
            this.resetInputsOnDateChange()
            this.vehicle.dateMEC = $('#vehicleDateMEC').val()
            this.onChangeDateMEC()
          }
      );
    },

    showNewQuotationForms() {
      this.resetVehicleInfos(true)

      this.showNewQuotationFormsClicked = !this.showNewQuotationFormsClicked

      this.existingQuoteList = []
      this.getExistingQuotesClicked = false

      this.showManualSearchButton = true
      this.showByLicensePlateSearchButton = true

      this.showExistingQuotationFiltersClicked = false
    },

    showExistingQuotationFilters() {
      this.resetVehicleInfos(true)

      this.showExistingQuotationFiltersClicked = !this.showExistingQuotationFiltersClicked

      this.existingQuoteList = []
      this.getExistingQuotesClicked = false

      this.showManualSearchButton = false
      this.showByLicensePlateSearchButton = false

      this.showNewQuotationFormsClicked = false
    },

    updateVehicleBodyValue(body) {
      this.vehicle.body = body
      this.onChangeBodyOptions()
    },

    updateVehicleFuelValue(fuel) {
      this.vehicle.fuel = fuel
      this.onChangeFuelOptions()
    },

    updateVehicleGearTypeValue(gearType) {
      this.vehicle.gearType = gearType
      this.onChangeGearTypeOptions()
    },

    updateVehicleDoorsValue(doors) {
      this.vehicle.doors = doors
      this.onChangeDoorsOptions()
    },

    isQuotationValid(estimationDate) {
      return moment().subtract(7, 'days').isBefore(moment(estimationDate, "DD-MM-YYYY HH:mm"))
    },

    onPlaceChanged(place, type) {
      this[type].address = formatAddress(place)
      this.getAvailablePartners()
    },
    async getAvailablePartners() {
      this.getAvailablePartnersIsLoading = true
      this.getAvailablePartnersError = false

      this.$apollo.query({
        query: gql`
                      query {
                       availablePartnersWithoutValuation(
                            realm: "${this.entity}",
                            address: "${this.vehicle.address.address}",
                            zipcode: "${this.vehicle.address.zipCode}",
                            city: "${this.vehicle.address.city}"
                       ) {
                            inspector {
                                id
                                name
                                address
                                accessInfo
                                zipcode
                                city
                                email
                                phoneNumber
                                cellNumber
                                isActive
                                maxMinutes
                                calendar
                            }

                       }
                      }`,
        fetchPolicy: 'no-cache'
      }).then(response => {
        this.vehicle.availablePartners = response.data.availablePartnersWithoutValuation
        if (!this.vehicle.availablePartners.inspector) {
          this.getAvailablePartnersNoDataError = true
        }
        this.getAvailablePartnersIsLoading = false
      }, () => {
        this.showBanner('danger', 'Désolé, un problème est survenu lors de la recherche des partenaires disponibles sur la zone')
        this.vehicle.availablePartners = []
        this.getAvailablePartnersError = true
        this.getAvailablePartnersIsLoading = false
      })
    },
    formatVersionOptions(versionOptions) {
      let formattedVersionOptions = []
      let i
      for (i = 0; i < versionOptions.length; i++) {
        let formattedNameArray = versionOptions[i].name.split("#")
        versionOptions[i].name = formattedNameArray[0]
        formattedVersionOptions.push(versionOptions[i])
      }
      return formattedVersionOptions
    },
    getExistingQuotesDuplicates(existingQuoteList) {
      let makeArray = []
      let modelArray = []
      let versionArray = []
      let kilometersArray = []

      let i;
      for (i = 0; i < existingQuoteList.length; i++) {
        makeArray.push(existingQuoteList[i].car.make)
        modelArray.push(existingQuoteList[i].car.model)
        versionArray.push(existingQuoteList[i].car.version)
        kilometersArray.push(existingQuoteList[i].car.kilometers)
      }

      let makeDuplicate = this.checkForDuplicates(makeArray)
      let modelDuplicate = this.checkForDuplicates(modelArray)
      let versionDuplicate = this.checkForDuplicates(versionArray)
      let kilometersDuplicate = this.checkForDuplicates(kilometersArray)

      let duplicatesObject = {
        'makeDuplicate': makeDuplicate,
        'modelDuplicate': modelDuplicate,
        'versionDuplicate': versionDuplicate,
        'kilometersDuplicate': kilometersDuplicate
      }

      return duplicatesObject
    },
    checkForDuplicates(itemArray) {
      let itemDuplicate = false
      let itemCounts = {}

      let x;
      for (x = 0; x < itemArray.length; x++) {
        itemCounts[itemArray[x]] = (itemCounts[itemArray[x]] || 0) + 1;
        if (Object.keys(itemCounts).length > 1) {
          itemDuplicate = true;
          break;
        }
      }

      return itemDuplicate
    },
    getWarningMessage(object) {
      let warningMessage = ""
      if (object.makeDuplicate) {
        warningMessage += " marques"
        if (object.modelDuplicate || object.versionDuplicate || object.kilometersDuplicate) {
          warningMessage += ","
        } else {
          warningMessage += "."
        }
      }
      if (object.modelDuplicate) {
        warningMessage += " modèles"
        if (object.versionDuplicate || object.kilometersDuplicate) {
          warningMessage += ","
        } else {
          warningMessage += "."
        }
      }
      if (object.versionDuplicate) {
        warningMessage += " versions"
        if (object.kilometersDuplicate) {
          warningMessage += ","
        } else {
          warningMessage += "."
        }
      }
      if (object.kilometersDuplicate) {
        warningMessage += " kilométrage."
      }
      return warningMessage
    }
  },
}
</script>

<style scoped>

</style>
